import store from "../store";

export const getToken = () => {
    return (
        store.state?.authToken ||
        localStorage.getItem("authToken") ||
        localStorage.getItem("token") ||
        ""
    );
};

export const getHeaders = (isMultipart = false) => {
    const token = getToken();
    const headers = {
        Authorization: `Bearer ${token}`
    };
    if (isMultipart) {
        headers['X-Requested-With'] = 'XMLHttpRequest';
    }
    return headers;
};

export default {
    getToken,
    getHeaders
};
